import React, { useState } from "react";
import img1 from "../images/banner.jpg";
import cakeimg1 from "../images/birthdaycake.jpg"
import cakeimg4 from "../images/specialoccision.jpg"
import cakeimg5 from "../images/marriage.jpg"
import cakeimg6 from "../images/anniversey.jpg"

import { NavLink } from "react-router-dom";

const products = [
  { id: 1, name: "Birth Day", image: cakeimg1 },
    { id: 3, name: "Marriage & Engagement", image: cakeimg5 },
  { id: 4, name: "Anniversey", image: cakeimg6 },
  { id: 2, name: "Special Occision", image: cakeimg4 },

 
];

const CakebyCategory = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="products-section" id="products">
      <h2>Cakes By Category</h2>
      <div className="productlist-grid">
        {products.map((item) => (
          <div
            className="product-card"
        
          >
            <NavLink to={`/cakes`}>
              <img  className="product-image" src={item.image} alt={item.name} />
              <h4 className="product-name">{item.name}</h4>
            </NavLink>
   <a
              href={`https://wa.me/919666696905?text=Hi, I would like to order: ${encodeURIComponent(item.name)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-order-btn"
            >
              Order Now via WhatsApp
            </a>

          </div>
        
        ))}
      </div>

      {/* Modal View */}
      {/* {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal content
          >
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              &times;
            </button>
            <img src={selectedImage} alt="Large view" className="modal-img" />
          </div>
        </div>
      )} */}
    </section>
  );
};

export default CakebyCategory;
